import React from 'react';
import { newClusterByCategoryData } from 'service/service';
import ClusterDetailsTableBase from './ClusterDetailsTableBase';

const ClusterProvisionedDetailsTable: React.FC = () => {
    return (
        <ClusterDetailsTableBase
            serviceFunc={newClusterByCategoryData}
            pageSubHeaderDefault="New Clusters Provisioned By Category"
            preserveFilterKey="cluster_provisioned_details_table"
            tableType="cluster-provisioned-details-table"
            backPath="/databricksADB/cluster_provisioned_by_category"
            backBreadcrumbName="New Clusters Provisioned By Category"
        />
    );
};

export default ClusterProvisionedDetailsTable;